export default function authHeader(obf) {
  const user = JSON.parse(localStorage.getItem("userData"));
  if (user && user.token) {
    return { Authorization: "Bearer " + user.token, Platform: 'Web',...obf };
  } else {
    return { Platform: 'Web',...obf};
  }
}
